module.exports = __webpack_public_path__ + "static/media/ico-info.5be8c50b.svg";